export const BrandonGrotesque = {
  boldItalic: 'brandon_grotesque_bold_italic',
  bold: 'brandon_grotesque_bold',
  blackItalic: 'brandon_grotesque_black_italic',
  black: 'brandon_grotesque_black',
  lightItalic: 'brandon_grotesque_light_italic',
  light: 'brandon_grotesque_light',
  mediumItalic: 'brandon_grotesque_medium_italic',
  medium: 'brandon_grotesque_medium',
  regularItalic: 'brandon_grotesque_regular_italic',
  regular: 'brandon_grotesque_regular',
  thinItalic: 'brandon_grotesque_thin_italic',
  thin: 'brandon_grotesque_thin',
};



// WEBPACK FOOTER //
// ./src/module/View/Common/const/Fonts.ts